import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from '@emotion/styled';

import { RootState } from '../../../store/rootReducer';
import { useProductsInfos } from '../../common/hooks/useProductsInfos';
import { setUpSellLoading } from '../actions';
import { breakpoints } from '../../../design-system';
import { RecommendationsBlock } from '../../recommendations/components/RecommendationsBlock';

const StyledUpSellContainer = styled.div`
  overflow-x: hidden;
  margin-top: 24px;

  @media (min-width: ${breakpoints.S}px) {
    margin-top: 0;
  }

  @media (min-width: ${breakpoints.M}px) {
    margin-top: 56px;
  }
`;

type Props = {
  upSellRefs: string[];
  loading: boolean;
};

export const UpSell = ({ upSellRefs, loading }: Props) => {
  const dispatch = useDispatch();
  const { up_sell_title: title } = useSelector((state: RootState) => state.cms.product);
  const { hits } = useProductsInfos(upSellRefs);

  useEffect(() => {
    if (
      (!loading && upSellRefs?.length > 0 && hits.length === upSellRefs?.length) ||
      (!loading && upSellRefs?.length === 0)
    ) {
      dispatch(setUpSellLoading(false));
    }
  }, [upSellRefs, hits, loading]);

  if (!upSellRefs.length || loading) {
    return null;
  }

  return (
    <StyledUpSellContainer>
      <RecommendationsBlock id="product-page" hits={hits} title={title} />
    </StyledUpSellContainer>
  );
};
